import {FC, useCallback} from 'react';
import {useField} from 'formik';
import MultiSelect, {MultiSelectInputProps} from '../inputs/MultiSelect';

interface MultiSelectProps extends MultiSelectInputProps {
  fieldDescription?: string,
  onChangeCallback?: (value) => void,
}

const MultiSelectField: FC<MultiSelectProps> = ({
  name,
  id,
  label,
  options,
  onFocus,
  onBlur,
  apiValidationError,
  onChangeCallback,
  size,
  disabled
}) => {
  const [
    {value},
    {error, touched},
    {setTouched, setValue}
  ] = useField(name);

  const handleChange = useCallback(({target: {value: newValue}}) => {
    if (onChangeCallback) {
      return onChangeCallback(newValue);
    }

    setValue(newValue);
    setTouched(true);
  }, [onChangeCallback]);

  const handleDeleteValue = (valueToDelete) => {
    const newValue =
      value.filter((selectedValue) => selectedValue !== valueToDelete);

    handleChange({target: {value: newValue}});
  };

  return (
    <MultiSelect
      name={name}
      id={id}
      label={label}
      options={options}
      value={value}
      onChange={handleChange}
      error={error}
      touched={touched}
      onFocus={onFocus}
      onBlur={onBlur}
      apiValidationError={apiValidationError}
      size={size}
      onDeleteSelectedValue={handleDeleteValue}
      disabled={disabled}
    />
  );
};

export default MultiSelectField;
